"use strict";

import Page from "./Dashboard.jsx";

export const auth = true;
export const title = "i18n:dashboard.pageTitle";
export const Component = Page;
